import { ReactNode, useCallback } from 'react';

import { markWizardStarted } from '@cartwhl/common/utils/wizardPersistence';
import {
  WizardHost,
  WizardProvider,
  type WizardEndReason,
} from '@cartwhl/ui/wizard';

import CanvasWizardAutoLaunch from './CanvasWizardAutoLaunch';
import { CANVAS_WIZARD_USER_STARTED_KEY_BY_ID } from './canvasWizards';

export default function CanvasWizardProvider({
  children,
}: {
  children: ReactNode;
}) {
  const handleWizardEnd = useCallback(
    (wizardId: string, reason: WizardEndReason) => {
      if (reason !== 'completed' && reason !== 'ended') {
        return;
      }

      const startedKey = CANVAS_WIZARD_USER_STARTED_KEY_BY_ID[wizardId];
      if (startedKey) {
        void markWizardStarted(startedKey);
      }
    },
    [],
  );

  return (
    <WizardProvider onWizardEnd={handleWizardEnd}>
      {children}
      <CanvasWizardAutoLaunch />
      <WizardHost />
    </WizardProvider>
  );
}
